import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

const FETCH_BRANDS = 'client/FETCH_BRANDS'
const FETCH_BRANDS_SUCCESS = 'client/FETCH_BRANDS_SUCCESS'
const FETCH_BRANDS_FAIL = 'client/FETCH_BRANDS_FAIL'

export const actions = {
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAIL
}

export const initialState = {
  brands: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRANDS:
      return {
        ...state,
        loading: true
      }
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload,
        loading: false
      }
    case FETCH_BRANDS_FAIL:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}

export default reducer

export function fetchBrands() {
  return {
    type: CALL_API,
    types: [FETCH_BRANDS, FETCH_BRANDS_SUCCESS, FETCH_BRANDS_FAIL],
    callAPI: () => axios.get('/brands', { ...fetchOptions('v1') })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/client.js